import type { IntlShape } from 'react-intl';

export const SAVE_DOCUMENT_CACHE_KEY = 'save-sfdt-reviewer-page';

export const getConstants = (intl: IntlShape) => {
  const TICKET_COMMENT_CHIP = {
    icon: 'lock' as const,
    text: intl.formatMessage({
      id: 'TicketReviewerPageConstants.ticketComment',
      defaultMessage: 'Ticket comment',
      description: 'Label for ticket comment chip',
    }),
  };
  const DOCUMENT_COMMENT_CHIP = {
    icon: 'globe' as const,
    text: intl.formatMessage({
      id: 'TicketReviewerPageConstants.documentComment',
      defaultMessage: 'Document comment',
      description: 'Label for document comment chip',
    }),
  };
  const ERROR_MESSAGES = {
    403: {
      preset: 'page-access',
      title: intl.formatMessage({
        id: 'TicketReviewerPageConstants.noAccessTitle',
        defaultMessage: 'No Access to Ticket',
        description: 'Title for no access error',
      }),
      description: intl.formatMessage({
        id: 'TicketReviewerPageConstants.noAccessDescription',
        defaultMessage:
          "You don't have access to this Ticket. Contact your administrator for access. Please return to Tickets to continue.",
        description: 'Description for no access error',
      }),
    },
    default: {
      preset: 'page-not-found',
      title: intl.formatMessage({
        id: 'TicketReviewerPageConstants.ticketNotFoundTitle',
        defaultMessage: 'Ticket Not Found',
        description: 'Title for ticket not found error',
      }),
      description: intl.formatMessage({
        id: 'TicketReviewerPageConstants.ticketNotFoundDescription',
        defaultMessage:
          'We could not find the ticket requested. Please return to Tickets to continue',
        description: 'Description for ticket not found error',
      }),
    },
  };

  return {
    TICKET_COMMENT_CHIP,
    DOCUMENT_COMMENT_CHIP,
    ERROR_MESSAGES,
  };
};
